const info = {
  25: '#FCFCFF',
  50: '#F4F3FF',
  100: '#ECE9FE',
  200: '#DBD6FE',
  300: '#C0B5FD',
  400: '#A18AFB',
  500: '#835BF7',
  600: '#7239EE',
  700: '#6327DA',
  800: '#5220B5',
  900: '#291065',
};
export default info;